import { identityZones } from '@/mocks/home';
import { getTone } from '@/pages/home/lib/tone';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function IdentityZones() {
  return (
    <section id="zones" className="w-full px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeading
          kicker="Identity Sections / 身份分区"
          index="01 — 四类身份"
          title="先选身份，再找反差"
          desc="同一个人在不同场合的样子，往往被拆散在不同的报道里。我们按身份把条目归好档，你只需要挑一类开始看。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {identityZones.map((zone) => {
            const tone = getTone(zone.tone);
            return (
              <article
                key={zone.key}
                className="flex flex-col justify-between rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-foreground-300"
              >
                <div>
                  <div className={`h-1 w-10 rounded-full ${tone.solidBg}`} />
                  <div
                    className={`mt-5 flex h-11 w-11 items-center justify-center rounded-md ${tone.softBg} ${tone.softText}`}
                  >
                    <i className={`${zone.icon} text-xl`} />
                  </div>
                  <p className="mt-4 font-label text-[10px] uppercase tracking-[0.3em] text-foreground-400">
                    {zone.latin}
                  </p>
                  <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950">
                    <a href="#dossier" className="transition-colors hover:text-primary-600">
                      {zone.label}
                    </a>
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{zone.desc}</p>
                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {zone.keywords.map((kw) => (
                      <span
                        key={kw}
                        className={`rounded-full px-2.5 py-1 font-label text-[11px] ${tone.softBg} ${tone.softText}`}
                      >
                        {kw}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="mt-6 flex items-end justify-between border-t border-dashed border-foreground-300 pt-4">
                  <div>
                    <p className="font-heading text-2xl font-bold text-foreground-950">{zone.count}</p>
                    <p className="font-label text-[11px] text-foreground-500">已归档条目</p>
                  </div>
                  <a
                    href="#dossier"
                    aria-label={`进入${zone.label}档案架`}
                    className={`flex h-9 w-9 items-center justify-center rounded-md border ${tone.border} ${tone.text} transition-colors hover:bg-background-200`}
                  >
                    <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}